<nz-spin [nzSpinning]="loading" [nzTip]="'importacao.dpara.loading'|translateTA">
  <div class="dialog-content custom-dialog-container form-field-density-4">

    <div *ngIf="!loading" class="form-field-density-4">
      <h2>{{'importacao.dpara.title'|translateTA}} {{data.instanceName}}</h2>
      <div class="header-config">
        <div class="header-config-left">
          <div *ngIf="!isJSON">
            <label nz-checkbox [(ngModel)]="hasHeader">{{'importacao.dpara.hasHeader'|translateTA}}</label>
          </div>
          <div>
            <label nz-checkbox [(ngModel)]="hasUpdate">{{'importacao.dpara.hasUpdate'|translateTA}}</label>
          </div>
          <div>
            <label nz-checkbox [(ngModel)]="multiCompany">{{'importacao.dpara.multiCompany'|translateTA}}</label>
          </div>
        </div>
        <nz-divider nzType="vertical" class="stretch-divider"></nz-divider>
        <div class="header-config-right">
          <div *ngIf="isJSON" class="tem-field example-full-width">
            <label class="tem-field-label">{{'importacao.dpara.endpoint'|translateTA}}</label>
            <input nz-input class="endpoint" [(ngModel)]="url">
          </div>
          <div *ngIf="isJSON" class="tokenForm">
            <div class="tem-field example-full-width">
              <label class="tem-field-label">{{'importacao.dpara.token'|translateTA}}</label>
              <input nz-input class="endpoint" [(ngModel)]="token">
            </div>
            <button nz-button nzType="primary" (click)="loadJsonFromEndpoint()" class="load-json-button">{{'importacao.dpara.fetchInfo'|translateTA}}</button>
          </div>
          <div class="tem-field example-full-width" *ngIf="!isJSON">
            <label class="tem-field-label">{{'importacao.dpara.headerLine'|translateTA}}</label>
            <input nz-input [(ngModel)]="headerLineNumber">
          </div>
        </div>

      </div>
      <div class="table-container">
        <nz-table #dparaTable [nzData]="columns" [nzShowPagination]="false" [nzFrontPagination]="false" nzSize="small" *ngIf="!isJSON">
          <thead>
            <tr>
              <th>{{'importacao.dpara.colDesc'|translateTA}}</th>
              <th>{{'importacao.dpara.colField'|translateTA}}</th>
              <th>{{'importacao.dpara.colType'|translateTA}}</th>
              <th>{{'importacao.dpara.colPk'|translateTA}}</th>
              <th>{{'importacao.dpara.colDpara'|translateTA}}</th>
              <th>{{'importacao.dpara.colFormula'|translateTA}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let column of dparaTable.data">
              <td class="cell-align-center">{{column.COLUMNDESC}}</td>
              <td class="cell-align-center">{{column.COLUMNNAME}}</td>
              <td class="cell-align-center">{{column.DATATYPE}} ( {{column.COLSIZE}} )</td>
              <td class="cell-align-center">
                <span *ngIf="column.ISPK === 1">{{'importacao.dpara.yes'|translateTA}}</span>
                <span *ngIf="column.ISPK !== 1">-</span>
              </td>
              <td class="cell-align-center">
                <input nz-input class="compact-field" [(ngModel)]="column.dparaValue">
              </td>
              <td class="cell-align-center">
                <div class="formula-cell">
                  <input nz-input class="compact-field formula-field" [(ngModel)]="column.formula">
                  <button nz-button nzType="text" nzShape="circle" (click)="openEditFormula(column)" type="button">
                    <nz-icon nzType="more"></nz-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>

    </div>
  </div>

  <div class="dialog-actions">
    <button nz-button nzDanger (click)="dialogRef.close()">{{'importacao.btn.cancel'|translateTA}}</button>
    <button nz-button nzType="primary" (click)="dialogRef.close({
      columns: columns,
      hasHeader: hasHeader,
      hasUpdate: hasUpdate,
      multiCompany: multiCompany,
      headerLineNumber: headerLineNumber
    })" cdkFocusInitial>{{'importacao.btn.ok'|translateTA}}</button>
  </div>
</nz-spin>
